import { useState } from "react";
import type { ComposerEditSummary } from "../../api/queries/adminQueries";

type ComposerEditPanelProps = {
  composerEdit: ComposerEditSummary;
};

export const ComposerEditPanel = ({ composerEdit }: ComposerEditPanelProps) => {
  const [showGenerated, setShowGenerated] = useState(true);
  const [showEdited, setShowEdited] = useState(true);

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50/80 p-4">
      <h3 className="text-sm font-semibold text-slate-700">Composer edits</h3>
      <p className="mt-1 text-sm text-slate-600">
        Edit distance:{" "}
        <span className="font-medium text-slate-800">
          {composerEdit.edit_distance}
        </span>
      </p>

      <div className="mt-3 space-y-3">
        <div>
          <button
            type="button"
            onClick={() => setShowGenerated((v) => !v)}
            className="text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
          >
            {showGenerated ? "▼" : "▶"} Generated (from trace)
          </button>
          {showGenerated ? (
            <div
              className="mt-2 max-h-48 overflow-auto rounded-md border border-slate-200 bg-white p-3 text-sm text-slate-700"
              dangerouslySetInnerHTML={{ __html: composerEdit.generated_html }}
            />
          ) : null}
        </div>
        <div>
          <button
            type="button"
            onClick={() => setShowEdited((v) => !v)}
            className="text-xs font-semibold uppercase tracking-wide text-slate-500 hover:text-slate-700"
          >
            {showEdited ? "▼" : "▶"} Edited (saved / sent)
          </button>
          {showEdited ? (
            <div
              className="mt-2 max-h-48 overflow-auto rounded-md border border-slate-200 bg-white p-3 text-sm text-slate-700"
              dangerouslySetInnerHTML={{ __html: composerEdit.edited_html }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
